import { createApp } from 'vue';
import App from './App.vue';

export default function init() {
  const element = document.getElementById('branchApp');

  if (element) {
    const app = createApp(App);

    app.mount('#branchApp');
  }
}
